import * as React from 'react';

import { Button, useCompassTheme } from '@circleci/compass';

import { outerTheme } from './styles';

type DefaultButtonProps = JSX.IntrinsicElements['button'] & {
  href?: undefined;
};
type ButtonAsLinkProps = JSX.IntrinsicElements['a'] & {
  href: string;
};
// Please see https://github.com/typescript-cheatsheets/react/issues/167#issuecomment-751347673
// for why it's typed like this
type ButtonProps = DefaultButtonProps | ButtonAsLinkProps;
type PolymorphicButton = {
  (props: ButtonProps): React.ReactElement<ButtonProps>;
  defaultProps?: Partial<ButtonProps>;
};

export const MarketingButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonProps
>((props, ref) => {
  const theme = useCompassTheme();

  const buttonCss = {
    backgroundColor: outerTheme.colors.marketingGreen,
    height: '48px',
    fontSize: '18px',
    lineHeight: '24px !important',
    fontWeight: 700,
    fontStyle: 'normal',
    borderRadius: '4px',
    border: 'none',
    transition: 'background-color 300ms',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    cursor: 'pointer',

    '&:hover:not(:disabled)': {
      backgroundColor: outerTheme.colors.marketingGreenHover,
    },
    '&:active:not(:disabled)': {
      backgroundColor: theme.colors.green600,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  };

  return props.href ? (
    <Button
      {...(props as React.PropsWithChildren<ButtonAsLinkProps>)}
      ref={ref as React.ForwardedRef<HTMLAnchorElement>}
      style={buttonCss}
    />
  ) : (
    <Button
      {...(props as React.PropsWithChildren<DefaultButtonProps>)}
      ref={ref as React.ForwardedRef<HTMLButtonElement>}
      style={buttonCss}
    />
  );
}) as PolymorphicButton;
